module.exports = __webpack_public_path__ + "static/media/total_accident.4b3825b2.png";